import { BOTONES } from '../../../../../componentes/botones';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { CardHeaderComponent } from '../../../../../componentes/card-header/card-header.component';
import { FilaNSComponent } from '../detalles-dispositivo-lorawan/fila-ns/fila-ns.component';

export interface DataFilaNS {
  idDispositivo: string;
  nombre?: string;
}

// Envoltorio de diálogo de la vista de fila del NS de UN dispositivo, para
// poder abrirla desde el listado sin pasar por el detalle. Es la misma vista
// que la solapa: acá sólo se le pone marco y título.
@Component({
  selector: 'app-fila-ns-dialog',
  standalone: true,
  imports: [
    CommonModule,
    BOTONES,
    MatCardModule,
    CardHeaderComponent,
    FilaNSComponent,
  ],
  template: `
    <mat-card>
      <app-card-header
        title="Fila de downlinks (NS)"
        [subtitle]="data.nombre || ''"
        icono="playlist_play"
        [botonCerrar]="true"
        (cerrar)="cerrar()"
      ></app-card-header>
      <mat-card-content class="card-content-crear">
        <app-fila-ns
          [idDispositivo]="data.idDispositivo"
          [enTarjeta]="false"
        ></app-fila-ns>
      </mat-card-content>
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="cerrar()">
          Cerrar
        </button>
      </mat-card-actions>
    </mat-card>
  `,
})
export class FilaNSDialogComponent {
  public dialogRef = inject<MatDialogRef<FilaNSDialogComponent>>(MatDialogRef);
  public data = inject<DataFilaNS>(MAT_DIALOG_DATA);

  public cerrar(): void {
    this.dialogRef.close();
  }
}
